<template>
  <footer>
    <router-link to="/terms-of-use">
      <span class="terms">Terms of use</span>
    </router-link>
    <router-link to="/privacy-and-data-notice">
      <span class="privacy">Privacy and data notice</span>
    </router-link>
    <span class="copyright">Copyright © 2020 Frogero.com</span>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #11b6a5;

  a {
    text-decoration: none;
    color: white;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    height: 6rem;
    justify-content: space-evenly;
  }

  .terms {
    transition: 0.2s;
    &:hover {
      color: #ebc659;
      cursor: pointer;
    }
  }

  .privacy {
    margin-left: 3rem;
    transition: 0.2s;
    &:hover {
      color: #ebc659;
      cursor: pointer;
    }
    @media (max-width: 600px) {
      margin-left: unset;
    }
  }

  .copyright {
    margin-left: 3rem;
    transition: 0.2s;
    @media (max-width: 600px) {
      margin-left: unset;
    }
  }
}
</style>